import { apiV2 } from "@/store";
import { cloneDeep } from "lodash";

const defaultState = {
  smsOptIn: {
    phone_number: "",
    value: ""
  },
  loading: false
};

export const state = cloneDeep(defaultState);

export const actions = {
  get: ({ state, dispatch, commit }, phoneNumber) => {
    state.loading = true;
    commit("resetSmsOptIn");
    return apiV2.get(`sms-opt-in/${phoneNumber}`)
      .then((response) => {
        if (!response.data || !response.data.hasOwnProperty("value") || !response.data.hasOwnProperty("phone_number")) {
          throw new Error("Unexpected response");
        }
        state.smsOptIn = response.data;
      })
      .catch((err) => {
        dispatch("handleError", err, { root: true });
      }).finally(() => {
        state.loading = false;
      });
  },
  update: ({ state, dispatch }, payload) => {
    if (!payload.hasOwnProperty("value") || !payload.hasOwnProperty("phone_number")) {
      return;
    }
    state.smsOptIn = defaultState.smsOptIn;
    state.loading = true;
    return apiV2.patch(`sms-opt-in/${payload.phone_number}`, { value: payload.value })
      .then((response) => {
        if (!response.data || !response.data.hasOwnProperty("value") || !response.data.hasOwnProperty("phone_number")) {
          throw new Error("Unexpected response");
        }
        state.smsOptIn = response.data;
        let successMessage;
        if (response.data.value) {
          successMessage = "Phone number added to SMS Opt-in list";
        } else {
          successMessage = "Phone number removed from SMS Opt-in list";
        }
        dispatch("handleSuccess", successMessage, { root: true });
      })
      .catch((err) => {
        dispatch("handleError", err, { root: true });
      })
      .finally(() => {
        state.loading = false;
      });
  }
};

export const mutations = {
  resetSmsOptIn(state) {
    state.smsOptIn = cloneDeep(defaultState.smsOptIn);
  }
};

export default {
  state,
  actions,
  mutations,
  namespaced: true
};
